import script from "./scene-select-dialog.vue?vue&type=script&lang=tsx&setup=true"
export * from "./scene-select-dialog.vue?vue&type=script&lang=tsx&setup=true"

import "./scene-select-dialog.vue?vue&type=style&index=0&id=b7327da0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7327da0"]])

export default __exports__